// import isIpadPro12Inch from './utilities/isIpadPro12Inch';

let hasTouchScreen = false;
if ('maxTouchPoints' in navigator) {
  hasTouchScreen = navigator.maxTouchPoints > 0;
} else if ('msMaxTouchPoints' in navigator) {
  hasTouchScreen = navigator.msMaxTouchPoints > 0;
} else {
  const mQ = window.matchMedia && matchMedia('(pointer:coarse)');
  if (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  ) {
    hasTouchScreen = true;
  } else if (mQ && mQ.media === '(pointer:coarse)') {
    hasTouchScreen = !!mQ.matches;
  } else if ('orientation' in window) {
    hasTouchScreen = true; // deprecated, but good fallback
  }
}
let replaceClassName = 'js';
replaceClassName += hasTouchScreen ? ' touch' : ' no-touch';
// replaceClassName += Array.from(
//   window.getComputedStyle(document.documentElement)
// ).some((propertyName) => propertyName.indexOf('-moz-') === 0)
//   ? ' firefox'
//   : ' no-firefox';
// replaceClassName += window.ApplePaySession ? ' safari' : '';
replaceClassName +=
  navigator.userAgent.includes('iP') ||
  (navigator.userAgent.includes('Mac') && navigator.maxTouchPoints > 4)
    ? ' ios'
    : '';
// replaceClassName += isIpadPro12Inch() ? ' ipad-pro-12' : '';

// const isDesktop = window.matchMedia(
//   `((orientation: landscape) and (min-width: 768px) and (max-width: 1024px)), (min-width: 1024px)`
// );
// const isMobile = window.matchMedia(
//   `(max-width: 768px), ((orientation: portrait) and (min-width: 768px) and (max-width: 1024px))`
// );
// if (isDesktop.matches) replaceClassName += ' desktop';
// else if (isMobile.matches) replaceClassName += ' mobile';

document.documentElement.className = document.documentElement.className.replace(
  /\bno-js\b/g,
  replaceClassName
);

document.addEventListener('DOMContentLoaded', () => {
  document.documentElement.className =
    document.documentElement.className.replace(/\bno-domready\b/g, 'domready');
});

function resize() {
  document.documentElement.style.setProperty(
    '--w-vh',
    // window.innerHeight * 0.01 + 'px'
    Math.min(
      document.documentElement.clientHeight,
      window.screen.height,
      window.innerHeight
    ) *
      0.01 +
      'px'
  );
}
resize();
window.addEventListener('resize', resize);
